goog.provide('el8.appchart.dialog.removeOrder');

goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.uiwidget.QuickSelectDialog');
goog.require('el8.service.urls');


/**
 * Used for owned orders in visit notes and non-visit notes
 * (right now, specifically for doc meds and referral orders)
 * to allow the user to choose whether X-ing out an order implies
 * deleting it from the whole chart or just the note.
 */
el8.appchart.dialog.removeOrder = (function() {

    var note = null;
    var item = null;
    var removeCallbackFn = null;

    var that = new el8.uiwidget.QuickSelectDialog({
        title: 'Remove Order from Note?',
        callbackFn: function(index) {
            var lookup = [
                function() {
                    el8.uiwidget.deleteConfirm("order",
                        function() {
                            that.hide();
                            var entitySet = el8.ptdata.getEntitySet(item.getModelClass());
                            entitySet.deleteItem(item);
                        }
                    );
                },
                function() {
                    if (removeCallbackFn) { 
                        removeCallbackFn(item);
                    }
                    that.hide();
                },
                function() { that.hide(); }
            ];
            return lookup[index] ? lookup[index]() : null;
        },
        list: [
            'Permanently delete from record',
            'Remove from note but keep in record',
            'Cancel'
        ]
    });

    var super_show = that.show;
    that.show = function(_note, _item, _removeCallbackFn) {
        super_show.call(that);
        item = _item;
        note = _note;
        removeCallbackFn = _removeCallbackFn;
    };

    return that;

})();


